import { lazy } from 'react';

const Home = lazy(() => import('./pages/Home'));
const About = lazy(() => import('./pages/About'));
const Contact = lazy(() => import('./pages/Contact'));

const Ndr = lazy(() => import('./pages/Solutions/Ndr'));
const DatabaseSecurity = lazy(() => import('./pages/Solutions/DatabaseSecurity'));
const MultiCloudSecurity = lazy(() => import('./pages/Solutions/MultiCloudSecurity'));
const SoftwareSolution = lazy(() => import('./pages/Solutions/SoftwareSolution'));
const CyberEssential = lazy(() => import('./pages/Solutions/CyberEssential'));
const IsoAccreditation = lazy(() => import('./pages/Solutions/IsoAccreditation'));
const CommsInfrastructure = lazy(() => import('./pages/Solutions/CommsInfrastructure'));
const VoipHostedVoice = lazy(() => import('./pages/Solutions/VoipHostedVoice'));
const Connectivity = lazy(() => import('./pages/Solutions/Connectivity'));
const BusinessMobile = lazy(() => import('./pages/Solutions/BusinessMobile'));
const CombineSave = lazy(() => import('./pages/Solutions/CombineSave'));

const routes = [
  { path: '/', element: Home, index: true },
  { path: '/about', element: About },
  { path: '/contact', element: Contact },
  { path: '/solutions/ndr', element: Ndr },
  { path: '/solutions/database-security', element: DatabaseSecurity },
  { path: '/solutions/multi-cloud-security', element: MultiCloudSecurity },
  { path: '/solutions/software-solution', element: SoftwareSolution },
  { path: '/solutions/cyber-essential', element: CyberEssential },
  { path: '/solutions/iso-accreditation', element: IsoAccreditation },
  { path: '/solutions/comms-infrastructure', element: CommsInfrastructure },
  { path: '/solutions/voip-and-hosted-voice', element: VoipHostedVoice },
  { path: '/solutions/connectivity', element: Connectivity },
  { path: '/solutions/business-mobile', element: BusinessMobile },
  { path: '/solutions/combine-and-save', element: CombineSave },
];

export default routes;
